// test1170
(1170 && 0);
